/**
 * @file tool to dynamically load data from files
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import win11_6_09CustomFeatureDependencies from '../assets/MSTR11_6_09/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_6_06CustomFeatureDependencies from '../assets/MSTR11_6_06/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_6_03CustomFeatureDependencies from '../assets/MSTR11_6_03/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_5_12CustomFeatureDependencies from '../assets/MSTR11_5_12/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_5_09CustomFeatureDependencies from '../assets/MSTR11_5_09/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_5_06CustomFeatureDependencies from '../assets/MSTR11_5_06/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_5_03CustomFeatureDependencies from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_4_12CustomFeatureDependencies from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';

import win11_6_09CustomComment from '../assets/MSTR11_6_09/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_6_09ExpressComment from '../assets/MSTR11_6_09/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_6_06CustomComment from '../assets/MSTR11_6_06/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_6_06ExpressComment from '../assets/MSTR11_6_06/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_6_03CustomComment from '../assets/MSTR11_6_03/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_6_03ExpressComment from '../assets/MSTR11_6_03/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_5_12CustomComment from '../assets/MSTR11_5_12/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_5_12ExpressComment from '../assets/MSTR11_5_12/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_5_09CustomComment from '../assets/MSTR11_5_09/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_5_09ExpressComment from '../assets/MSTR11_5_09/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_5_06CustomComment from '../assets/MSTR11_5_06/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_5_06ExpressComment from '../assets/MSTR11_5_06/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_5_03CustomComment from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_5_03ExpressComment from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_4_12CustomComment from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_4_12ExpressComment from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';

import {
    featureKey2StateMap as win11_6_09CustomFeatureKey2StateMap,
    pic2StateMap as win11_6_09CustomPic2StateMap,
} from '../assets/MSTR11_6_09/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_6_06CustomFeatureKey2StateMap,
    pic2StateMap as win11_6_06CustomPic2StateMap,
} from '../assets/MSTR11_6_06/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_6_03CustomFeatureKey2StateMap,
    pic2StateMap as win11_6_03CustomPic2StateMap,
} from '../assets/MSTR11_6_03/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_5_12CustomFeatureKey2StateMap,
    pic2StateMap as win11_5_12CustomPic2StateMap,
} from '../assets/MSTR11_5_12/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_5_09CustomFeatureKey2StateMap,
    pic2StateMap as win11_5_09CustomPic2StateMap,
} from '../assets/MSTR11_5_09/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_5_06CustomFeatureKey2StateMap,
    pic2StateMap as win11_5_06CustomPic2StateMap,
} from '../assets/MSTR11_5_06/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_5_03CustomFeatureKey2StateMap,
    pic2StateMap as win11_5_03CustomPic2StateMap,
} from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_4_12CustomFeatureKey2StateMap,
    pic2StateMap as win11_4_12CustomPic2StateMap,
} from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    state2PrefixMap as win11_6_09ExpressState2PrefixMap,
    state2CommentMap as win11_6_09ExpressState2CommentMap,
} from '../assets/MSTR11_6_09/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_6_09CustomState2PrefixMap,
    state2CommentMap as win11_6_09CustomState2CommentMap,
} from '../assets/MSTR11_6_09/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_6_06ExpressState2PrefixMap,
    state2CommentMap as win11_6_06ExpressState2CommentMap,
} from '../assets/MSTR11_6_06/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_6_06CustomState2PrefixMap,
    state2CommentMap as win11_6_06CustomState2CommentMap,
} from '../assets/MSTR11_6_06/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_6_03ExpressState2PrefixMap,
    state2CommentMap as win11_6_03ExpressState2CommentMap,
} from '../assets/MSTR11_6_03/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_6_03CustomState2PrefixMap,
    state2CommentMap as win11_6_03CustomState2CommentMap,
} from '../assets/MSTR11_6_03/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_5_12ExpressState2PrefixMap,
    state2CommentMap as win11_5_12ExpressState2CommentMap,
} from '../assets/MSTR11_5_12/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_5_12CustomState2PrefixMap,
    state2CommentMap as win11_5_12CustomState2CommentMap,
} from '../assets/MSTR11_5_12/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_5_09ExpressState2PrefixMap,
    state2CommentMap as win11_5_09ExpressState2CommentMap,
} from '../assets/MSTR11_5_09/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_5_09CustomState2PrefixMap,
    state2CommentMap as win11_5_09CustomState2CommentMap,
} from '../assets/MSTR11_5_09/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_5_06ExpressState2PrefixMap,
    state2CommentMap as win11_5_06ExpressState2CommentMap,
} from '../assets/MSTR11_5_06/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_5_06CustomState2PrefixMap,
    state2CommentMap as win11_5_06CustomState2CommentMap,
} from '../assets/MSTR11_5_06/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_5_03ExpressState2PrefixMap,
    state2CommentMap as win11_5_03ExpressState2CommentMap,
} from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_5_03CustomState2PrefixMap,
    state2CommentMap as win11_5_03CustomState2CommentMap,
} from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_4_12ExpressState2PrefixMap,
    state2CommentMap as win11_4_12ExpressState2CommentMap,
} from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_4_12CustomState2PrefixMap,
    state2CommentMap as win11_4_12CustomState2CommentMap,
} from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import win11_6_09CustomPageObjects from '../assets/MSTR11_6_09/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_6_09ExpressPageObjects from '../assets/MSTR11_6_09/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_6_06CustomPageObjects from '../assets/MSTR11_6_06/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_6_06ExpressPageObjects from '../assets/MSTR11_6_06/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_6_03CustomPageObjects from '../assets/MSTR11_6_03/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_6_03ExpressPageObjects from '../assets/MSTR11_6_03/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_5_12CustomPageObjects from '../assets/MSTR11_5_12/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_5_12ExpressPageObjects from '../assets/MSTR11_5_12/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_5_09CustomPageObjects from '../assets/MSTR11_5_09/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_5_09ExpressPageObjects from '../assets/MSTR11_5_09/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_5_06CustomPageObjects from '../assets/MSTR11_5_06/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_5_06ExpressPageObjects from '../assets/MSTR11_5_06/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_5_03CustomPageObjects from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_5_03ExpressPageObjects from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_4_12CustomPageObjects from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_4_12ExpressPageObjects from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';

import win11_6_09CustomStates from '../assets/MSTR11_6_09/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_6_09ExpressStates from '../assets/MSTR11_6_09/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_6_06CustomStates from '../assets/MSTR11_6_06/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_6_06ExpressStates from '../assets/MSTR11_6_06/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_6_03CustomStates from '../assets/MSTR11_6_03/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_6_03ExpressStates from '../assets/MSTR11_6_03/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_5_12CustomStates from '../assets/MSTR11_5_12/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_5_12ExpressStates from '../assets/MSTR11_5_12/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_5_09CustomStates from '../assets/MSTR11_5_09/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_5_09ExpressStates from '../assets/MSTR11_5_09/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_5_06CustomStates from '../assets/MSTR11_5_06/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_5_06ExpressStates from '../assets/MSTR11_5_06/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_5_03CustomStates from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_5_03ExpressStates from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_4_12CustomStates from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_4_12ExpressStates from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressStates.json';

import win11_6_09CustomSummaryStructure from '../assets/MSTR11_6_09/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_6_09ExpressSummaryStructure from '../assets/MSTR11_6_09/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_6_06CustomSummaryStructure from '../assets/MSTR11_6_06/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_6_06ExpressSummaryStructure from '../assets/MSTR11_6_06/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_6_03CustomSummaryStructure from '../assets/MSTR11_6_03/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_6_03ExpressSummaryStructure from '../assets/MSTR11_6_03/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_5_12CustomSummaryStructure from '../assets/MSTR11_5_12/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_5_12ExpressSummaryStructure from '../assets/MSTR11_5_12/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_5_09CustomSummaryStructure from '../assets/MSTR11_5_09/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_5_09ExpressSummaryStructure from '../assets/MSTR11_5_09/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_5_06CustomSummaryStructure from '../assets/MSTR11_5_06/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_5_06ExpressSummaryStructure from '../assets/MSTR11_5_06/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_5_03CustomSummaryStructure from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_5_03ExpressSummaryStructure from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_4_12CustomSummaryStructure from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_4_12ExpressSummaryStructure from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';

import {
    WINDOWS_11_6_09_CUSTOM,
    WINDOWS_11_6_09_EXPRESS,
    WINDOWS_11_6_06_CUSTOM,
    WINDOWS_11_6_06_EXPRESS,
    WINDOWS_11_6_03_CUSTOM,
    WINDOWS_11_6_03_EXPRESS,
    WINDOWS_11_5_12_CUSTOM,
    WINDOWS_11_5_12_EXPRESS,
    WINDOWS_11_5_09_CUSTOM,
    WINDOWS_11_5_09_EXPRESS,
    WINDOWS_11_5_06_CUSTOM,
    WINDOWS_11_5_06_EXPRESS,
    WINDOWS_11_5_03_CUSTOM,
    WINDOWS_11_5_03_EXPRESS,
    WINDOWS_11_4_12_CUSTOM,
    WINDOWS_11_4_12_EXPRESS,
} from '../Utils/Constants';

export let featureDependencies = win11_5_03CustomFeatureDependencies;
export let comment = win11_5_03CustomComment;
export let featureKey2StateMap = win11_5_03CustomFeatureKey2StateMap;
export let pic2StateMap = win11_5_03CustomPic2StateMap;
export let state2PrefixMap = win11_5_03CustomState2PrefixMap;
export let state2CommentMap = win11_5_03CustomState2CommentMap;
export let pageObjects = win11_5_03CustomPageObjects;
export let states = win11_5_03CustomStates;
export let summaryStructure = win11_5_03CustomSummaryStructure;

export const winLoadData = (installation) => {
    switch (installation) {
        case WINDOWS_11_6_09_CUSTOM:
            featureDependencies = win11_6_09CustomFeatureDependencies;
            comment = win11_6_09CustomComment;
            featureKey2StateMap = win11_6_09CustomFeatureKey2StateMap;
            pic2StateMap = win11_6_09CustomPic2StateMap;
            state2PrefixMap = win11_6_09CustomState2PrefixMap;
            state2CommentMap = win11_6_09CustomState2CommentMap;
            pageObjects = win11_6_09CustomPageObjects;
            states = win11_6_09CustomStates;
            summaryStructure = win11_6_09CustomSummaryStructure;
            break;
        case WINDOWS_11_6_06_CUSTOM:
            featureDependencies = win11_6_06CustomFeatureDependencies;
            comment = win11_6_06CustomComment;
            featureKey2StateMap = win11_6_06CustomFeatureKey2StateMap;
            pic2StateMap = win11_6_06CustomPic2StateMap;
            state2PrefixMap = win11_6_06CustomState2PrefixMap;
            state2CommentMap = win11_6_06CustomState2CommentMap;
            pageObjects = win11_6_06CustomPageObjects;
            states = win11_6_06CustomStates;
            summaryStructure = win11_6_06CustomSummaryStructure;
            break;
        case WINDOWS_11_6_03_CUSTOM:
            featureDependencies = win11_6_03CustomFeatureDependencies;
            comment = win11_6_03CustomComment;
            featureKey2StateMap = win11_6_03CustomFeatureKey2StateMap;
            pic2StateMap = win11_6_03CustomPic2StateMap;
            state2PrefixMap = win11_6_03CustomState2PrefixMap;
            state2CommentMap = win11_6_03CustomState2CommentMap;
            pageObjects = win11_6_03CustomPageObjects;
            states = win11_6_03CustomStates;
            summaryStructure = win11_6_03CustomSummaryStructure;
            break;
        case WINDOWS_11_5_12_CUSTOM:
            featureDependencies = win11_5_12CustomFeatureDependencies;
            comment = win11_5_12CustomComment;
            featureKey2StateMap = win11_5_12CustomFeatureKey2StateMap;
            pic2StateMap = win11_5_12CustomPic2StateMap;
            state2PrefixMap = win11_5_12CustomState2PrefixMap;
            state2CommentMap = win11_5_12CustomState2CommentMap;
            pageObjects = win11_5_12CustomPageObjects;
            states = win11_5_12CustomStates;
            summaryStructure = win11_5_12CustomSummaryStructure;
            break;
        case WINDOWS_11_5_09_CUSTOM:
            featureDependencies = win11_5_09CustomFeatureDependencies;
            comment = win11_5_09CustomComment;
            featureKey2StateMap = win11_5_09CustomFeatureKey2StateMap;
            pic2StateMap = win11_5_09CustomPic2StateMap;
            state2PrefixMap = win11_5_09CustomState2PrefixMap;
            state2CommentMap = win11_5_09CustomState2CommentMap;
            pageObjects = win11_5_09CustomPageObjects;
            states = win11_5_09CustomStates;
            summaryStructure = win11_5_09CustomSummaryStructure;
            break;
        case WINDOWS_11_5_06_CUSTOM:
            featureDependencies = win11_5_06CustomFeatureDependencies;
            comment = win11_5_06CustomComment;
            featureKey2StateMap = win11_5_06CustomFeatureKey2StateMap;
            pic2StateMap = win11_5_06CustomPic2StateMap;
            state2PrefixMap = win11_5_06CustomState2PrefixMap;
            state2CommentMap = win11_5_06CustomState2CommentMap;
            pageObjects = win11_5_06CustomPageObjects;
            states = win11_5_06CustomStates;
            summaryStructure = win11_5_06CustomSummaryStructure;
            break;
        case WINDOWS_11_5_03_CUSTOM:
            featureDependencies = win11_5_03CustomFeatureDependencies;
            comment = win11_5_03CustomComment;
            featureKey2StateMap = win11_5_03CustomFeatureKey2StateMap;
            pic2StateMap = win11_5_03CustomPic2StateMap;
            state2PrefixMap = win11_5_03CustomState2PrefixMap;
            state2CommentMap = win11_5_03CustomState2CommentMap;
            pageObjects = win11_5_03CustomPageObjects;
            states = win11_5_03CustomStates;
            summaryStructure = win11_5_03CustomSummaryStructure;
            break;
        case WINDOWS_11_4_12_CUSTOM:
            featureDependencies = win11_4_12CustomFeatureDependencies;
            comment = win11_4_12CustomComment;
            featureKey2StateMap = win11_4_12CustomFeatureKey2StateMap;
            pic2StateMap = win11_4_12CustomPic2StateMap;
            state2PrefixMap = win11_4_12CustomState2PrefixMap;
            state2CommentMap = win11_4_12CustomState2CommentMap;
            pageObjects = win11_4_12CustomPageObjects;
            states = win11_4_12CustomStates;
            summaryStructure = win11_4_12CustomSummaryStructure;
            break;

        case WINDOWS_11_6_09_EXPRESS:
            comment = win11_6_09ExpressComment;
            state2PrefixMap = win11_6_09ExpressState2PrefixMap;
            state2CommentMap = win11_6_09ExpressState2CommentMap;
            pageObjects = win11_6_09ExpressPageObjects;
            states = win11_6_09ExpressStates;
            summaryStructure = win11_6_09ExpressSummaryStructure;
            break;
        case WINDOWS_11_6_06_EXPRESS:
            comment = win11_6_06ExpressComment;
            state2PrefixMap = win11_6_06ExpressState2PrefixMap;
            state2CommentMap = win11_6_06ExpressState2CommentMap;
            pageObjects = win11_6_06ExpressPageObjects;
            states = win11_6_06ExpressStates;
            summaryStructure = win11_6_06ExpressSummaryStructure;
            break;
        case WINDOWS_11_6_03_EXPRESS:
            comment = win11_6_03ExpressComment;
            state2PrefixMap = win11_6_03ExpressState2PrefixMap;
            state2CommentMap = win11_6_03ExpressState2CommentMap;
            pageObjects = win11_6_03ExpressPageObjects;
            states = win11_6_03ExpressStates;
            summaryStructure = win11_6_03ExpressSummaryStructure;
            break;
        case WINDOWS_11_5_12_EXPRESS:
            comment = win11_5_12ExpressComment;
            state2PrefixMap = win11_5_12ExpressState2PrefixMap;
            state2CommentMap = win11_5_12ExpressState2CommentMap;
            pageObjects = win11_5_12ExpressPageObjects;
            states = win11_5_12ExpressStates;
            summaryStructure = win11_5_12ExpressSummaryStructure;
            break;
        case WINDOWS_11_5_09_EXPRESS:
            comment = win11_5_09ExpressComment;
            state2PrefixMap = win11_5_09ExpressState2PrefixMap;
            state2CommentMap = win11_5_09ExpressState2CommentMap;
            pageObjects = win11_5_09ExpressPageObjects;
            states = win11_5_09ExpressStates;
            summaryStructure = win11_5_09ExpressSummaryStructure;
            break;
        case WINDOWS_11_5_06_EXPRESS:
            comment = win11_5_06ExpressComment;
            state2PrefixMap = win11_5_06ExpressState2PrefixMap;
            state2CommentMap = win11_5_06ExpressState2CommentMap;
            pageObjects = win11_5_06ExpressPageObjects;
            states = win11_5_06ExpressStates;
            summaryStructure = win11_5_06ExpressSummaryStructure;
            break;
        case WINDOWS_11_5_03_EXPRESS:
            comment = win11_5_03ExpressComment;
            state2PrefixMap = win11_5_03ExpressState2PrefixMap;
            state2CommentMap = win11_5_03ExpressState2CommentMap;
            pageObjects = win11_5_03ExpressPageObjects;
            states = win11_5_03ExpressStates;
            summaryStructure = win11_5_03ExpressSummaryStructure;
            break;
        case WINDOWS_11_4_12_EXPRESS:
            comment = win11_4_12ExpressComment;
            state2PrefixMap = win11_4_12ExpressState2PrefixMap;
            state2CommentMap = win11_4_12ExpressState2CommentMap;
            pageObjects = win11_4_12ExpressPageObjects;
            states = win11_4_12ExpressStates;
            summaryStructure = win11_4_12ExpressSummaryStructure;
            break;
        default:
    }
};
